import cx from "classnames";
import { memo, useMemo } from "react";

import s from "./WLSubscriptionPlanCard.module.scss";
import {
  ViewWLSubscriptionsTiers,
  WLStripeWPlanSubscription,
} from "../../../Common/models/subscriptions";
import { IonLabel } from "@ionic/react";
import { WLDivider } from "../../../Common/components/WLDivider/WLDivider";
import { WLButton } from "../../../Common/components/WLButton/WLButton";
import {
  subscriptionCommonStyles,
  SubscriptionType,
} from "../../../Common/constants/subscriptionConst";
import { isNull, toUpper } from "lodash";
import { formatMembershipRenewalLabel } from "../../../Common/utils/subscriptionDateFormat";

const WLSubscriptionPlanCard = ({
  subscription,
  onSelect,
  existingSubscription,
  mode,
  subscriptionButtonText: subscriptionBtnTextProp,
}: {
  onSelect: (subscription: ViewWLSubscriptionsTiers) => void;
  subscription: ViewWLSubscriptionsTiers;
  existingSubscription?: WLStripeWPlanSubscription | null;
  mode?:
  | "downgrade"
  | "upgrade"
  | "currentMembership"
  | "subscription"
  | "retryPayment";
  subscriptionButtonText?: string;
}) => {
  const name = (subscription?.name ?? "Starter") as SubscriptionType;

  const { cardStyle, cardIcon, dividerStyle } = subscriptionCommonStyles[name];

  const subscriptionButtonText = useMemo(() => {
    if (subscriptionBtnTextProp) {
      return subscriptionBtnTextProp;
    }

    switch (mode) {
      case "downgrade":
        return `Downgrade to ${toUpper(subscription.name)}`;
      case "upgrade":
        return `Upgrade to ${toUpper(subscription.name)}`;
      case "subscription":
        return `Get ${toUpper(subscription.name)} membership`;
      case "retryPayment":
        return "Retry Payment";
      case "currentMembership":
        if (
          existingSubscription !== undefined &&
          !isNull(existingSubscription)
        ) {
          return formatMembershipRenewalLabel(
            existingSubscription.current_period_end,
          );
        }
      // else continue
      default:
        return `Sign Up`;
    }
  }, [subscription, mode, subscriptionBtnTextProp]);

  return (
    <div className={cx(s.subscriptionCardContainer)}>
      <div className={cx(s.subscriptionCard)} style={cardStyle}>
        <div className={s.cardTitleRow}>
          <IonLabel
            className={cx(
              s.subscriptionCardTitle,
              "win-header-7 medium winnersans primary ion-text-uppercase"
            )}
          >
            {subscription.name}
          </IonLabel>
          <img src={cardIcon} className={s.subscriptionIcon} alt="" loading="lazy" decoding="async" />
        </div>
        <IonLabel className={cx(s.accumEntriesLbl, "win-sub medium gilroy")}>
          <span
            className={cx(
              s.accumEntriesLblMainText1,
              "win-headline-2 medium winnersans"
            )}
          >
            {subscription.entriesPerMonth}
          </span>
          <span
            className={cx(
              s.accumEntriesLblMainText2,
              "win-header-7 medium winnersans primary"
            )}
          >
            {" "}
            ENTRIES{" "}
          </span>
          into every giveaway
        </IonLabel>
        <IonLabel
          className={cx(
            s.subscriptionPrice,
            "win-header-7 medium winnersans primary"
          )}
        >
          {subscription.priceString}
          <span className={cx(s.slash, "win-header-3 gilroy")}>/</span>
          <span
            className={cx(
              s.subscriptionPricePerMonth,
              "win-body medium gilroy"
            )}
          >
            per month
          </span>
        </IonLabel>

        <WLButton
          className={cx(
            s.subscriptionButton,
            "red-submit-button win-sub medium gilroy"
          )}
          onClick={() => {
            onSelect(subscription);
          }}
        >
          {subscriptionButtonText}
        </WLButton>
        <WLDivider className={cx(s.divider)} style={dividerStyle} />
        {subscription.benefits.map((benefit, index) => {
          return (
            <div className={s.benefitContainer} key={`benefit-${index}`}>
              <li
                className={cx(s.benefit, "win-sub gilroy regular")}
                dangerouslySetInnerHTML={{
                  __html: benefit,
                }}
              ></li>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default memo(WLSubscriptionPlanCard);
